import { actionCreatorFactory } from 'typescript-fsa';
import { AlertType } from '@cbridge-packages/alert';
import { ISubscriptionSettings, ISubscriptionEmail } from './alertSubscription.interface';

export namespace AlertSubscriptionAction {
  const actionCreator = actionCreatorFactory('AlertSubscription');

  export const loadSubscriptions = actionCreator.async<void, ISubscriptionSettings>('LOAD_SUBSCRIPTIONS');
  export const updateSubscription = actionCreator.async<{ type: AlertType; enabled: boolean }, void>('UPDATE_SUBSCRIPTION');
  export const addEmailToSubscription = actionCreator.async<{
    email: string;
    type: AlertType;
    enabled: boolean;
  }, void>('ADD_EMAIL_TO_SUBSCRIPTION');
  export const addEmail = actionCreator.async<ISubscriptionEmail, void>('ADD_EMAIL');
  export const deleteEmail = actionCreator.async<ISubscriptionEmail, void>('DELETE_EMAIL');
  export const destroy = actionCreator('DESTROY');
}
